export default __webpack_public_path__ + "static/media/img_jboss-colorBkg.ec6b3ca9.png";